"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _color = _interopRequireDefault(require("webmotors-react-pj/tokens/color"));
var _responsive = _interopRequireDefault(require("webmotors-react-pj/tokens/responsive"));
var _default = exports.default = _styledComponents.default.header.withConfig({
  componentId: "sc-owgxrc-0"
})(["display:flex;flex-wrap:wrap;align-items:center;background-color:", ";position:fixed;min-height:56px;width:100%;z-index:99;&[data-header-popover]{z-index:5;}[data-icon-click]{cursor:pointer;}[data-icon-click] > *{pointer-events:none;}@media ", "{position:relative;height:56px;}"], (0, _color.default)('white'), _responsive.default.lg);